// extracted by mini-css-extract-plugin
module.exports = {"stripes":"styles-module--stripes--3AtOo","challengeBackground":"styles-module--challengeBackground--sbM3a"};